import { render, staticRenderFns } from "./sggl_2.vue?vue&type=template&id=2a3a64d0&scoped=true&"
import script from "./sggl_2.vue?vue&type=script&lang=js&"
export * from "./sggl_2.vue?vue&type=script&lang=js&"
import style0 from "./sggl_2.vue?vue&type=style&index=0&id=2a3a64d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a64d0",
  null
  
)

export default component.exports